import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import makeStyles from '@mui/styles/makeStyles';
import { FormWrapper } from 'components/elements/stepper/FormWrapper';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function TabletStepperForm({ activeStep, steps, children, navigation }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  return (
    <div data-testid="stepper-form">
      <h1 className={classes.tabletStepperHeader}>{t('request_an_appointment')}</h1>
      <Box className={classes.tabletStepperForm}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step) => (
            <Step key={step}>
              <StepLabel
                StepIconProps={{
                  classes: {
                    root: classes.step,
                  },
                }}
                className={classes.label}
              >
                {step}
              </StepLabel>
              <StepContent>
                <FormWrapper navigation={navigation}>{children}</FormWrapper>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </div>
  );
}

TabletStepperForm.propTypes = {
  activeStep: PropTypes.number.isRequired,
  navigation: PropTypes.element.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired,
};

export default TabletStepperForm;
